"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { SelectContent as t } from "../../atoms/Select/Select.mjs";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/molecules/SelectInput/SelectInputContent.tsx
var r = ({ className: r, children: i, ...a }) => /* @__PURE__ */ n(t, {
	className: e("min-w-38 rounded-xl px-0  dark:bg-neutral-dark-200 border dark:border-neutral-dark-300", r),
	...a,
	children: i
});
//#endregion
export { r as SelectInputContent };
